import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { ErrorStateMatcher, ShowOnDirtyErrorStateMatcher } from '@angular/material/core';
import { SharedModule } from '@shared/shared.module';
import { UserAgreementComponent } from './components/user-agreement/user-agreement.component';
import { UserRegistrationComponent } from './pages/user-registration/user-registration.component';
import { RegistrationRoutingModule } from './registration-routing.module';


@NgModule({
  declarations: [
    UserRegistrationComponent,
    UserAgreementComponent
  ],
  imports: [
    CommonModule,
    RegistrationRoutingModule,
    SharedModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: ErrorStateMatcher,
      useClass: ShowOnDirtyErrorStateMatcher
    },
  ]
})
export class RegistrationModule { }
